import React, { useEffect, useState } from 'react';
import { Route, Switch, useLocation }    from 'react-router-dom';
import NavigationStrip      from './components/navigation-strip';
import MagazineMain         from './screens/main';
import MagazineGeneric      from './screens/generic';
import BreadCrumbs          from 'components/common/bread_crumbs';
import Article              from './screens/Article';
import * as Routes          from 'constants/routes';
import { useDispatch, useSelector } from 'react-redux';

import './index.scss';
import { addPopup, getVideoArticleById } from "../../redux/actions";
import * as popups from "../../constants/popup-types";

const Magazine = () => {
    const location = useLocation();
    const pathname = location.pathname;

    const dispatch = useDispatch();
    const crumbs = useSelector(store => store.data.magazineCrumbs);
    const texts = useSelector(store => store.config.Translations);
    const categories = useSelector(store => store.data.magazineCategories);

    const isMobile = (useSelector(store =>  store.state.deviceState)) === 'mobile';

    // The ID and data of the video-article which should open on page load
    const videoArticleId = new URLSearchParams(location.search).get('videoId');
    const [videoArticleData, setVideoArticleData] = useState(null);

    // On initialization, check whether there's a video-article ID which should be visible, and get its data
    useEffect(() => {
        if (videoArticleId) {
            dispatch(getVideoArticleById(setVideoArticleData, { articleId: videoArticleId }));
        }
    }, []);

    // On response from server, dispatch the popup of the video-article which should be visible
    useEffect(() => {
        if (videoArticleData) {
            dispatch(addPopup({
                type: popups.VIDEO_ARTICLE,
                article: videoArticleData,
                shouldRedirect: true,
            }));
        }
    }, [videoArticleData]);

    const isMagazinePage = () => {
        const pathnameParts = pathname.split('/');
        return (
            pathnameParts.length < 4 || pathnameParts[2] === texts['magazine_video_category']
        );
    };

    return (
    <div className='magazine-wrapper'>

        <div className="header-strip">
        { isMagazinePage() && !isMobile && <div className="text">{texts['magazine_smart_consumerism']}</div> }
        { !isMagazinePage() && <NavigationStrip/> }
        </div>
        <BreadCrumbs
            className="magazine-bread-crumbs"
            root={{ text: 'דף הבית', route: Routes.home }}
            crumbs={[
                { text: texts['magazine_breadcrumb'], route: Routes.magazine },
                ...crumbs,
            ]}
        />
        { isMagazinePage() && <NavigationStrip/> }
        <Switch>
            <Route
                path={Routes.magazine}
                component={MagazineMain}
                exact
            />
            <Route
                path={Routes.magazine + '/' + texts['magazine_video_category']}
                exact
            >
                <MagazineGeneric category={texts['magazine_video_category']}/>
            </Route>
        {categories && categories.map((category, idx) => {
            const path = `${Routes.magazine}/${category.title}`;
            return (
                <Route key={idx} path={path} exact>
                    <MagazineGeneric category={category} />
                </Route>)
        })}
        {categories && categories.map((category, idx) => {
            const path = `${Routes.magazine}/${category.title}`;
            return (
                <Route key={idx+300} path={path + "/:articleId"}>
                    <Article category={category.title} />
                </Route>
            )
        })}
        </Switch>
    </div>);
}

export default Magazine;
